function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M82 41C82 63.6437 63.6437 82 41 82C18.3563 82 0 63.6437 0 41C0 18.3563 18.3563 0 41 0C63.6437 0 82 18.3563 82 41ZM15.58 41C15.58 55.0391 26.9609 66.42 41 66.42C55.0391 66.42 66.42 55.0391 66.42 41C66.42 26.9609 55.0391 15.58 41 15.58C26.9609 15.58 15.58 26.9609 15.58 41Z",
  fill: "#E9BA42",
  fillOpacity: 0.24
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M41 7.79C41 3.4877 44.5185 -0.0747186 48.7433 0.737838C53.4135 1.63604 57.9117 3.34379 62.0283 5.80324C68.385 9.60108 73.5946 15.0496 77.1038 21.5701C80.6129 28.0907 82.2906 35.4399 81.9588 42.8373C81.627 50.2348 79.298 57.4042 75.2191 63.5844C71.1402 69.7646 65.4637 74.7248 58.7924 77.9382C52.1211 81.1516 44.7041 82.4983 37.329 81.8353C29.9539 81.1723 22.896 78.5243 16.9048 74.1726C13.025 71.3544 9.68626 67.8899 7.0243 63.9489C4.61616 60.3837 6.50843 55.748 10.4643 54.0566C14.4201 52.3651 18.9249 54.3182 21.7309 57.5795C23.0093 59.0653 24.4609 60.4048 26.061 61.567C29.7755 64.2651 34.1514 65.9068 38.724 66.3179C43.2966 66.729 47.8951 65.894 52.0313 63.9017C56.1675 61.9094 59.6869 58.8341 62.2158 55.0023C64.7447 51.1706 66.1887 46.7256 66.3945 42.1392C66.6002 37.5528 65.56 32.9962 63.3843 28.9535C61.2086 24.9107 57.9787 21.5327 54.0375 19.178C52.3398 18.1637 50.5375 17.3557 48.6687 16.7643C44.5669 15.4664 41 12.0923 41 7.79Z",
  fill: "#E9BA42"
});

function SvgCircleLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleLoader);
export default __webpack_public_path__ + "static/media/circle-loader.592d6d8a.svg";
export { ForwardRef as ReactComponent };